// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  background: var(--color-white);
  padding: 1.5rem;
  border: 2px solid transparent;
  border-radius: var(--border-radius-1);
  transition: var(--transition);
}

.card:hover {
  background: transparent;
  border-color: var(--color-white);
  transform: translateY(-0.5rem);
}

.card.light {
  background: var(--color-light);
}

.card.light:hover {
  background: transparent;
  border-color: var(--color-light);
}

/* Media queries (phones */

@media screen and (max-width: 600px) {
  .card {
    padding: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/card/card.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,0BAA0B;;AAE1B;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".card {\n  background: var(--color-white);\n  padding: 1.5rem;\n  border: 2px solid transparent;\n  border-radius: var(--border-radius-1);\n  transition: var(--transition);\n}\n\n.card:hover {\n  background: transparent;\n  border-color: var(--color-white);\n  transform: translateY(-0.5rem);\n}\n\n.card.light {\n  background: var(--color-light);\n}\n\n.card.light:hover {\n  background: transparent;\n  border-color: var(--color-light);\n}\n\n/* Media queries (phones */\n\n@media screen and (max-width: 600px) {\n  .card {\n    padding: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
